module.exports = __webpack_public_path__ + "static/media/icon-business.50b9419d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icon-business.svg
 ** module id = 1617
 ** module chunks = 0
 **/